export default __webpack_public_path__ + "static/media/Employees.68069c68.png";